import script from "./FeedbackModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeedbackModal.vue?vue&type=script&setup=true&lang=ts"

import "./FeedbackModal.vue?vue&type=style&index=0&id=7a873938&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a873938"]])

export default __exports__